import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_ALLERGEN_EXCLUDED_ALLERGENS_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateAllergenIncludedAllergensDetailsArgs } from '../graphql/transformers'
import { UPDATE_ALLERGEN_EXCLUDED_ALLERGENS_DETAILS } from '../redux/action-types'

const useUpdateAllergenIncludedAllergensDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isIncludedAllergensDetailsLoading, includedAllergensDetailsError } =
    useSelector(store => store.allergens.allergen)

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_ALLERGEN_EXCLUDED_ALLERGENS_DETAILS_MUTATION,
        {
          id,
          data: transformToUpdateAllergenIncludedAllergensDetailsArgs(data),
        },
        dispatch,
        UPDATE_ALLERGEN_EXCLUDED_ALLERGENS_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    {
      isLoading: isIncludedAllergensDetailsLoading,
      error: includedAllergensDetailsError,
    },
  ]
}

export default useUpdateAllergenIncludedAllergensDetailsMutation
